import styled from 'styled-components';
import { useContext } from 'react';
import UITable from 'UIComponents/table/UITable';
import GutterContainer from './GutterContainer';
import { NEXT_COMPONENT_SPACING } from 'developer-docs-shared-components/config/cssConstants';
import { ContainerContext } from '../utils/ContainerContext';
import { TabsContext } from '../utils/TabsContext';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export const Spacer = styled.div.withConfig({
  displayName: "Table__Spacer",
  componentId: "l0yha9-0"
})(["margin-bottom:", "px;"], NEXT_COMPONENT_SPACING);
const Table = ({
  children,
  size = 'large',
  style,
  bordered
}) => {
  const isInsideTabs = useContext(TabsContext);

  // Content to be wrapped or not wrapped in GutterContainer
  const content = /*#__PURE__*/_jsx(View, {
    marginBlockEnd: "800",
    children: /*#__PURE__*/_jsx(UITable, {
      style: style,
      bordered: bordered,
      children: children
    })
  });
  return /*#__PURE__*/_jsx(ContainerContext.Provider, {
    value: "table",
    children: isInsideTabs ?
    // Skip GutterContainer when inside Tabs
    content :
    /*#__PURE__*/
    // Use GutterContainer when not inside Tabs
    _jsx(GutterContainer, {
      size: size,
      children: content
    })
  });
};
export default Table;